<template>
    <div class="order">
        <div class="search m-b-20">
            <div class="search-box flex-row">
                <img class="searchImg" :src="search" alt="" >
                <input class="searchVal" placeholder="请输入客户姓名/电话/订单号" v-model="value" type="text" @input="seachList">
            </div>
        </div>
        <ul class="orderList" >
            <li class="item m-b-20" v-for="(item, index) in orderList" :key="index" >
                <div class="title brder-b flex-row w100">
                    <div class="orderNumber">电子收据： {{ item.electronicReceiptNumber ? '' : '待生成' }}<span v-if="item.electronicReceiptNumber" @click="handelToElectronicNumber(item)">{{ item.electronicReceiptNumber}}</span>
                        <div class="packageType">
                            <span v-if="item.packageType === 0">标准订单</span>
                            <span style="background: #FF8C00;" v-if="item.packageType === 1">A套餐</span>
                            <span style="background: #28A745;" v-if="item.packageType === 2">B套餐</span>
                        </div>
                    </div>
                    <div class="orderStats" @click="viewPage(item)">
                        <span>补贴套餐明细</span>
                    </div>
                </div>
                <div class="product m-t-25">订单号：{{item.orderNumber}}</div>
                <div class="product m-t-25">付款单号：{{item.storeExpenditureNumber}}</div>
                <div class="product m-t-25">付款金额：{{item.paymentAmount}}</div>
                <div class="product m-t-25">审核状态：{{item.auditStatusName}}</div>
                <div class="product m-t-25">客户姓名：{{item.customerName}}</div>
                <div class="product m-t-25">客户电话：{{item.customerPhone}}</div>

                <div class="product m-t-25 w100">所属门店：{{item.storeName}} </div>
                <div class="item-footer-btn w100">
                    <div class="pay-qrcode"  @click="handelShowCode(item)" v-if="item.collectCodeUrl && item.auditStatus == 1">支付二维码</div>
                </div>
            </li>
        </ul>
        <van-popup 
            v-model="showPopup" 
            round 
            closeable
            position="center"
            :style="{ padding: '30px', textAlign: 'center' }"
            >
            <div class="qrcode-box">
                <!-- 静态二维码图片 -->
                <img 
                :src="imgUrl" 
                alt="QR Code" 
                class="qrcode-img" 
                />

                <!-- 提示文字 -->
            </div>
        </van-popup>
    </div>
</template>
<script>
import search from '@/assets/img/search.png';
import product from '@/assets/img/product.jpg';
import tel from '@/assets/img/tel.png';
import { listStoreExpenditure, getCollectCodeAccount } from '@/api/index';
import {  Toast, Popup } from 'vant';
export default {
    data(){
        return {
            search,
            product,
            tel,
            value:'',
            orderList:[],
            allOrderList: [],
            showPopup: false,
            imgUrl: ''
        }
    },
    components:{
        [Toast.name] : Toast,
        [Popup.name] : Popup
        
    },
    created(){
        this.$loca.getItem('routeItem', this.$route.path);
        this.getData();
    },
    methods:{
        getCollectCodeAccountFunc(collectCodeAccountId) {
            return new Promise((resolve, reject) => {
                getCollectCodeAccount({ collectCodeAccountId }).then(res=> {
                    if(res.status == 200) {
                        resolve(res.data)
                    }
                })
            })
        },
        viewPage(item){
            if(item.packageType == 1) {
                this.imgUrl = 'https://fanhuayiju.oss-cn-beijing.aliyuncs.com/wx_20260612161421_411_152.jpg'
            } else {
                this.imgUrl = 'https://fanhuayiju.oss-cn-beijing.aliyuncs.com/wx_20260612161428_412_152.jpg'
            }
            this.showPopup = true
        },
        handelToElectronicNumber(item) {
            item.url = item.receiptUrl
            this.$router.push({path:'viewPdfs',query:{ item: JSON.stringify(item) }});
        },
        async handelShowCode(item) {
            let urlData = await this.getCollectCodeAccountFunc(item.collectCodeAccountId)
            this.imgUrl = urlData.codeUrl
            this.showPopup = true
        },
        seachList(){
             const keyword = this.value.trim().toLowerCase();
            if (!keyword){
                this.orderList = this.allOrderList
                return
            }

            // 定义需要查询的字段
            const searchFields = ['orderNumber', 'customerName', 'customerPhone', 'address'];

            let list = this.allOrderList.filter(item => {
                return searchFields.some(field => {
                return String(item[field] || '').toLowerCase().includes(keyword);
                });
            });
            this.orderList = list  
        },
  
        /**
         * 获取订单列表
         * @method getData
         */
        getData(){
            let data = this.$loca.getItem('phone');       
            let name = this.$loca.getItem('name');
            listStoreExpenditure({customerPhone: data, limit: 999 ,orderNumber: this.value}).then(res => {
                if(res.status == 200) {
                    res.data.rows.forEach((item, index) => {
                        let obj = this.parsedOrder(item.remarks)
                        res.data.rows[index] = {
                            ...res.data.rows[index],
                            ...obj
                        } 
                    });
                    this.allOrderList = res.data.rows || []
                    this.orderList = res.data.rows || [];
                }
            }).catch(error => {
                console.log('获取合同列表 views/appointment/list.vue');
            })
        },
        parsedOrder(str) {
            
            // 使用正则表达式分别提取对应前缀后面的内容
            const orderMatch = str.match(/订单号[：:]\s*([^\s|]+)/);
            const nameMatch = str.match(/客户姓名[：:]\s*([^\s|]+)/);
            const phoneMatch = str.match(/客户电话[：:]\s*(\d+)/); // 电话通常是纯数字
            
            return {
            orderNumber: orderMatch ? orderMatch[1] : '',
            customerName: nameMatch ? nameMatch[1] : '',
            customerPhone: phoneMatch ? phoneMatch[1] : ''
            };
        }
    }
}
</script>
<style lang="scss" scoped>
.order{
    background: $color-ed;
    .van-toast{
        width: 300px;
    }
    .van-popup{
        padding: 30px 10px 10px 10px !important;
    }
    .search{
        height: 82px;
        background: $ffff;
        .search-box{
            width:670px;
            height:60px;
            background:rgba(255,255,255,1);
            border:2px solid rgba(229,229,229,1);
            border-radius:10px;
            margin:18px 0 0 39px;
            align-items: center;
            .searchImg{
                margin-left: 17px;
                width: 24px;
                height: 24px;
            }
            .searchVal{
                margin-left: 18px;
                width: 600px;
                height: 100%;
            }
        }
    }
    .item-footer-btn{
        padding: 20px 0;
        display: flex;
        justify-content: flex-end;
        &>div{
            padding: 10px 15px;
            margin-left: 15px;
            box-shadow: 0px 0px 5px #ccc;
            color: #fff;
            border-radius: 10px;
            &.pay-btn{
                background: #07C160;
            }
            &.pay-qrcode{
                background: #FF6B00;
            }
        }
    }
    .qrcode-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        }

        .qrcode-img {
        padding-top: 50px;
        width: 700px; 
        }
    .orderList{
        background: $color-ed;
        li{
            display: flex;
            flex-wrap: wrap;
            &>div{
                width: 50%;
                &.w100{
                    width: 100%;
                }
        }
            
        }
        .item{
            // height: 334px;
            background: $ffff;
            padding: 0 20px;
            padding-bottom: 20px;
            .flex-main.flex-main.flex-main{
                justify-content: flex-start;
                align-items: flex-start;
                div:nth-child(1) {
                    width: 120px;
                }
                div:nth-child(2) {
                    width: 550px;
                }
            }
            .title{
                padding: 18px 0 15px 0; 
                justify-content: space-between;
                .orderNumber{
                    font-size:24px;
                    color:rgba(51,51,51,1);
                    margin-left: 18px;
                    display: flex;
                    align-items: center;
                    &>span{
                        color: cornflowerblue;
                        font-size:24px;
                    }
                    .packageType{
                        margin-left: 10px;
                        color: #fff;
                        font-size: 24px;
                        
                        &>span{
                            font-size: 18px;
                            padding: 5px 10px;
                            border-radius: 10px;
                        }
                    }
                }
                .orderStats{
                    font-size:20px;
                    color:rgba(86,180,240,1);
                    margin-right: 11px;
                    span{
                        margin-left: 15px;
                    }
                }
            }
            .product{
                padding-left: 14px;
                box-sizing: border-box;
                font-size:24px;
                color: $color-102;
                align-items: center;
                .time{
                    margin-right: 11px;
                    font-size:20px;
                    color:$color-187;
                }
                .numbers{
                    font-size:24px;
                    color:$color-81;
                }
                .invoice{
                    margin-right: 11px;
                    font-size:20px;
                    color:$color-153;
                }
            }
            .products{
                margin-left: 14px;
                font-size:24px;
                color: $color-102;
                align-items: center;
                position: relative;
                .time{
                    margin-right: 11px;
                    font-size:20px;
                    color:$color-187;
                }
                .numbers{
                    font-size:24px;
                    color:$color-81;
                }
                .invoice{
                    margin-right: 11px;
                    font-size:20px;
                    position: absolute;
                    left: 350px;
                }
            }
            .info{
                padding: 16px 0 10px 0;
                font-size:24px;
                color:$color-153;
                width: auto;
                align-items: center;
                justify-content: space-between;
                img{
                    width: 54px;
                    height: 54px;
                }
                .information{
                    align-items:center;
                    .names{
                        margin-bottom: 7px;
                    }
                    img{
                        width: 65px;
                        height: 65px;
                        margin: 0 25px 0 21px;
                    }
                }
            }
        }
    }
}
.border-bottom{
    border-bottom:2px solid rgba(229,229,229,1);
}
.delivery{
    color:$color-162;
}
</style>

